(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-cart"]) return;
  try {
    
if(!customElements.get('vc-cart'))customElements.define('vc-cart',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.openHandler=()=>this.open();this.clickHandler=e=>{if(e.target.closest('.vc-cart-link')){e.preventDefault();this.open()}};document.addEventListener('vc:cart-open',this.openHandler);document.addEventListener('click',this.clickHandler);this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}});this.addEventListener('click',e=>{const remove=e.target.closest('[data-remove]');if(remove){e.preventDefault();this.change({id:remove.dataset.remove,quantity:0},'change')}});this.addEventListener('change',e=>{if(e.target.matches('[data-key]'))this.change({id:e.target.dataset.key,quantity:Number(e.target.value)},'change')});this.addEventListener('submit',e=>{if(e.submitter?.name==='checkout')return;e.preventDefault();const updates={};this.querySelectorAll('[data-key]').forEach(input=>updates[input.dataset.key]=Number(input.value));this.change({updates,note:this.querySelector('[name=note]')?.value||''},'update')});}
disconnectedCallback(){document.removeEventListener('vc:cart-open',this.openHandler);document.removeEventListener('click',this.clickHandler)}
async refresh(){const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'?section_id=vc-cart');if(!response.ok)throw Error(this.dataset.error);const html=new DOMParser().parseFromString(await response.text(),'text/html');const body=html.querySelector('[data-cart-body]');if(!body)throw Error(this.dataset.error);this.querySelector('[data-cart-body]').replaceChildren(...body.childNodes);const data=await fetch(root+'cart.js').then(r=>r.json());document.querySelectorAll('[data-vc-cart-count]').forEach(el=>{el.textContent=data.item_count;el.hidden=!data.item_count});}
async open(){this.returnFocus=document.activeElement;const error=this.querySelector('[data-cart-error]');error.hidden=true;try{await this.refresh()}catch(err){error.hidden=false;error.textContent=err.message}if(!this.dialog.open)this.dialog.showModal();this.dialog.addEventListener('close',()=>this.returnFocus?.focus(),{once:true});}
async change(body,endpoint){if(this.busy)return;this.busy=true;this.dialog.setAttribute('aria-busy','true');this.querySelectorAll('button,input,textarea').forEach(el=>el.disabled=true);const error=this.querySelector('[data-cart-error]');error.hidden=true;try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/'+endpoint+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});const result=await response.json();if(!response.ok)throw Error(result.description||this.dataset.error);await this.refresh()}catch(err){error.textContent=err.message;error.hidden=false}finally{this.busy=false;this.dialog.removeAttribute('aria-busy');this.querySelectorAll('button,input,textarea').forEach(el=>el.disabled=false)}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-offer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-vc-offer]').forEach(link=>link.addEventListener('click',e=>{const bundles=document.querySelector('vc-bundles');if(bundles){e.preventDefault();bundles.scrollIntoView({behavior:'smooth',block:'center'});bundles.querySelector('input[value="3"]').focus()}}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-popup"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vc-newsletter-popup'))customElements.define('vc-newsletter-popup',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const d=this.querySelector('dialog');this.querySelector('.vc-popup-close').addEventListener('click',()=>{d.close();sessionStorage.setItem('vc-newsletter-dismissed','1')});this.querySelector('.vc-popup-join').addEventListener('click',e=>{e.currentTarget.hidden=true;this.querySelector('[data-signup]').hidden=false;this.querySelector('input[type=email]').focus()});d.addEventListener('close',()=>sessionStorage.setItem('vc-newsletter-dismissed','1'));if(!sessionStorage.getItem('vc-newsletter-dismissed')&&!document.documentElement.classList.contains('shopify-design-mode'))setTimeout(()=>{if(this.isConnected)d.showModal()},20000)}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vc-product'))customElements.define('vc-product',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const lightbox=this.querySelector('.vc-lightbox');this.querySelector('.vc-gallery-main').addEventListener('click',()=>{this.querySelector('[data-zoom]').src=this.querySelector('[data-main]').src;lightbox.showModal()});this.querySelector('[data-close]').addEventListener('click',()=>lightbox.close());const form=this.querySelector('form');if(!form)return;const sticky=this.querySelector('[data-sticky]');if(sticky)new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0}).observe(form.querySelector('[name=add]'));const variants=JSON.parse(this.querySelector('[data-variants]').textContent),labels=JSON.parse(this.querySelector('[data-labels]').textContent);const bundles=form.querySelector('vc-bundles');
if(bundles){bundles.hidden=false;form.querySelectorAll('.vc-option,.vc-quantity,.vc-price').forEach(el=>el.hidden=true);bundles.addEventListener('change',e=>{if(e.target.matches('input[type=radio]'))bundles.querySelectorAll('[data-pack]').forEach(card=>card.toggleAttribute('data-active',card.dataset.pack===e.target.value));});
form.addEventListener('submit',async e=>{e.preventDefault();if(this.busy)return;const error=form.querySelector('[data-error]');error.hidden=true;const card=bundles.querySelector('[data-active]'),count=Number(card.dataset.pack),selected=[...card.querySelectorAll('[data-set]')].map(row=>{const values=[...row.querySelectorAll('select')].map(s=>s.value);return variants.find(variant=>variant.options.every((value,i)=>value===values[i]));});if(selected.some(x=>!x?.available)){error.textContent=labels.bundleError;error.hidden=false;return}this.busy=true;const btn=form.querySelector('[name=add]');btn.disabled=true;btn.textContent=labels.busy;let added=false;try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:selected.map(variant=>({id:variant.id,quantity:1}))})});const result=await response.json();if(!response.ok)throw Error(result.description||result.message);added=true;const code=count===3?'VENAROCOZY3':count===4?'VENAROCOZY4':'';if(code){const update=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code+',VENAROFREESHIP'})});const cart=await update.json();if(!update.ok||!cart.discount_codes?.some(d=>d.code.toUpperCase()===code&&d.applicable))throw Error(labels.addedError)}document.dispatchEvent(new CustomEvent('vc:cart-open'));if(!document.querySelector('vc-cart'))location.assign(root+'cart');}catch(err){error.textContent=added?labels.addedError:err.message;error.hidden=false;if(added)document.dispatchEvent(new CustomEvent('vc:cart-open'));}finally{this.busy=false;btn.disabled=false;btn.textContent=labels.add;}});}
this.querySelectorAll('[data-image]').forEach(b=>b.addEventListener('click',()=>{this.querySelector('[data-main]').src=b.dataset.image;this.querySelectorAll('[data-image]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)))}));form.addEventListener('change',e=>{if(e.target.closest('vc-bundles'))return;const values=[...form.querySelectorAll('.vc-option')].map(f=>f.querySelector('input:checked')?.value);const v=variants.find(x=>x.options.every((o,i)=>o===values[i]));const btn=form.querySelector('[name=add]');btn.disabled=!v?.available;btn.textContent=v?.available?labels.add:labels.sold;if(!v)return;form.querySelector('[name=id]').value=v.id;const money=n=>new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:labels.currency}).format(n/100);this.querySelector('[data-price]').textContent=money(v.price);const cmp=this.querySelector('[data-compare]');cmp.hidden=!(v.compare_at_price>v.price);cmp.textContent=money(v.compare_at_price||0);if(v.featured_image)this.querySelector('[data-main]').src=v.featured_image.src;if(location.pathname.includes('/products/')){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-reviews"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vc-reviews'))customElements.define('vc-reviews',class extends HTMLElement{connectedCallback(){this.querySelector('[data-more]')?.addEventListener('click',e=>{this.querySelectorAll('[hidden]').forEach(x=>x.hidden=false);e.currentTarget.hidden=true})}});
  } catch(e) { console.error(e); }
})();
})();
